import tw, { styled } from 'twin.macro';

const MarkdownTableCell = styled.td`
  ${tw`px-4 py-2`}
`;

export default MarkdownTableCell;
